'use client';

import { ExplorerSectionPage } from '../layout';

export default function ExplorerFinalLiveExecutionChecklistPage() {
  return <ExplorerSectionPage data-component-id="src/app/explorer/final-live-execution-checklist/page.tsx:6:9" data-component-path="src/app/explorer/final-live-execution-checklist/page.tsx" data-component-line="6" data-component-end-line="6" data-component-file="page.tsx" data-component-name="ExplorerSectionPage" data-component-content="%7B%22elementName%22%3A%22ExplorerSectionPage%22%7D" pageId="final-live-execution-checklist" />;
}
